/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { BearerToken, OEMName, DealerNumber } from '../../../configs/constant'
import { useEffect, useState } from 'react'

export const getAuthToken = () => {
  const [token, setToken] = useState()
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const bearerToken: any = urlParams.get(BearerToken)
    setToken(bearerToken)
  }, [token])
  return token
}

export const getOEMName = () => {
  const [oemName, setOEMName] = useState('')
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const oemNameValue: any = urlParams.get(OEMName)
    if (oemNameValue != null) {
      setOEMName(oemNameValue)
    }
  }, [oemName])
  return oemName
}

export const getDealerNumber = () => {
  const [dealerNumber, setDealerNumber] = useState('')
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const dealerNumberValue: any = urlParams.get(DealerNumber)
    if (dealerNumberValue != null) {
      setDealerNumber(dealerNumberValue)
    }
  }, [dealerNumber])
  return dealerNumber
}
